import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { SelectField } from 'redux-form-material-ui';
import { MenuItem } from 'material-ui';
import { presence } from 'dash-front/helpers/validation';

const SelectCampaignForm = ({ campaigns = [] }) => {
    return (
        <Field name={'campaignId'} validate={presence} floatingLabelText={'Select campaign'} component={SelectField}>
            {campaigns.map(campaign => {
                return <MenuItem key={campaign._id} value={campaign._id} primaryText={campaign.title} />;
            })}
        </Field>
    );
};

SelectCampaignForm.propTypes = {
    campaigns: PropTypes.array
};

export default SelectCampaignForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/SelectCampaignForm.js
 **/